import styled from 'styled-components'

import { MenuContentStyles } from '../Menu/Menu'
import Popover from '../Popover/Popover'

const StyledMenuContent = styled(Popover.Content).attrs({
  align: 'start',
  side: 'bottom',
  role: 'listbox',
  sideOffset: 1,
  onOpenAutoFocus: (e) => e.preventDefault(),
  onMouseDown: (e) => e.preventDefault(), // Prevent blurring input when selecting items
})<{ $layout?: 'column' | 'grid'; $gridItemWidth?: string }>`
  ${MenuContentStyles};
  min-width: var(--radix-popper-anchor-width);
  max-height: var(--radix-popover-content-available-height);
  gap: 1px;

  ${({ $layout = 'column', $gridItemWidth = '190px' }) =>
    $layout === 'column'
      ? `
    display: flex;
    flex-direction: column;
  `
      : `
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(${$gridItemWidth}, 1fr));
    align-items: stretch;
    justify-content: stretch;
    gap: 8px;
    width: 800px;
  `};
`
export default StyledMenuContent
